module.exports = __webpack_public_path__ + "img/picture_kcsplby01@2x.0abbaf1c.png";